const RESPONSE_STATUS = {
  IN_PROGRESS: 'in progress',
  FAILED: 'failed',
  SUCCEEDED: 'succeeded',
}

export { RESPONSE_STATUS }